<template>
  <Breadcrumbs
      title="Vehicle & SE Target"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Vehicle & SE Target', path: '/vehicle-se-target' },
    ]"
  />
  
  <div class="container-fluid">
    <div class="row project-cards">
      <vehicleSeTarget/>
    </div>
  </div>
</template>
  
<script>
import vehicleSeTarget from './vehicle_se_target_form.vue'
export default {
  name: 'indexList',
  components: {
    vehicleSeTarget,
  },
}
</script>